import { SortInfo } from '../scandata-query.models';
import { ScandataModel } from '../scandata.models';

export class SetRecycledScans {
  static readonly type = '[ScandataRecycle] SetRecycledScans';
  constructor(public readonly scans: ScandataModel[]) {}
}

export class SetSortInfo {
  static readonly type = '[ScandataRecycle] SetSortInfo';
  constructor(public readonly sortInfo: SortInfo) {}
}

export class SetPreviewVisible {
  static readonly type = '[ScandataRecycle] SetPreviewVisible';
  constructor(public readonly previewVisible: boolean) {}
}

export class SetSelectedRecycledScans {
  static readonly type = '[ScandataRecycle] SetSelectedRecycledScans';
  constructor(public readonly scans: ScandataModel[]) {}
}

export class RemoveRecycledScans {
  static readonly type = '[ScandataRecycle] RemoveRecycledScans';
  constructor(public readonly scanIds: string[]) {}
}

export class ClearRecycledScans {
  static readonly type = '[ScandataRecycle] ClearRecycledScans';
}
